import React from "react";
import { useTranslation } from "react-i18next";
//import { useTranslation } from "../../i18n/translationContext";
import Nav from "react-bootstrap/Nav";

import i18n, { loadTranslations } from "../../i18n/i18n";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    loadTranslations(lang)
      .then((translations) => {
        i18n.addResourceBundle(lang, "translation", translations, true, true);
      })
      .catch((error) => {
        console.error("Failed to load translations:", error);
      })
      .finally(() => {
        i18n.changeLanguage(lang);
        localStorage.setItem("language", lang); // Storing in local storage
      });
  };

  const languages = [
    { code: "en", text: "EN" },
    { code: "nl", text: "NL" },
  ];

  return (
    <Nav.Link>
      {languages.map((language, index) => (
        <React.Fragment key={language.code}>
          {index > 0 && <span className="navbar-text">/</span>}
          <span
            className={`i18n-option ${index === languages.length - 1 ? "ps-2" : "pe-2"} ${i18n.language === language.code ? "active" : ""}`}
            title={i18n.t(`languageSelector_${language.code.toUpperCase()}`)}
            style={{ fontWeight: i18n.language === language.code ? "bold" : "normal" }}
            onClick={() => changeLanguage(language.code)}
          >
            {language.text}
          </span>
        </React.Fragment>
      ))}
    </Nav.Link>
  );
};

export default LanguageSelector;
